export default "__VITE_ASSET__DhQRuCrE__"